import { gql, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import RefreshIcon from "./RefreshIcon";
import ChartAndTable from "./ChartAndTable";
import {
  prepareChartDataForUserActivityOneForIndividualApproach,
  prepareChartDataForUserActivityTwoForIndividualApproach,
  processUserActivityDataForIndividualApproach,
} from "./prepareChartData";
import { LoadTable } from "../../Components";

const UserPageActivity = gql`
  query GetAllUsersActivity($individually: Boolean) {
    getAllUsersActivity(individually: $individually)
  }
`;

const UserActivity = () => {
  const Key = "User_Activity";
  const [theme, setThemeOption] = useState("Theme1");
  const [TableData, setTableData] = useState([]);
  const [chartData, setChartData] = useState({});
  const [maxNumber, setMaxNumber] = useState(10000);
  const [options, setOption] = useState({});
  const [colAddition, setcolAddition] = useState([]);
  const { data, loading, error, refetch } = useQuery(UserPageActivity, {
    variables: {
      individually: true,
    },
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data?.getAllUsersActivity) {
      console.log(data?.getAllUsersActivity);
      let preparedData;
      if (theme === "Theme1") {
        preparedData = prepareChartDataForUserActivityOneForIndividualApproach(data?.getAllUsersActivity);
      } else {
        preparedData = prepareChartDataForUserActivityTwoForIndividualApproach(
          data?.getAllUsersActivity,
          "#00684a",
          "Total User Activity"
        );
      }
      setChartData(preparedData);
      const max = preparedData.datasets?.reduce((max, dataset) => Math.max(max, ...dataset.data), 0) || 0;
      setMaxNumber(max + max * 0.1);
    }
  }, [data, theme]);

  useEffect(() => {
    console.log(data);
    if (data?.getAllUsersActivity) {
      const { ColAddition, updatedData } = processUserActivityDataForIndividualApproach(data?.getAllUsersActivity);
      console.log(updatedData, data, "kkkkkkkkkkkkkkkkkk", ColAddition);
      setTableData(updatedData);
      setcolAddition(ColAddition);
    }
  }, [data]);

  useEffect(() => {
    const options1 = {
      responsive: true,
      plugins: {
        legend: { position: "top" },
        title: { display: false, text: "User Activity" },
      },
      scales: {
        x: {
          reverse: true,
          title: { display: true, text: "Time Range" },
          ticks: { maxRotation: 90, minRotation: 90, autoSkip: false },
        },
        y: { min: 0, max: maxNumber, ticks: { stepSize: 10 }, title: { display: true, text: "User Activity Count" } },
      },
    };

    const options2 = {
      responsive: true,
      plugins: {
        legend: { position: "top" },
        title: { display: false, text: "User Activity" },
        tooltip: {
          callbacks: {
            label: function (context) {
              return context.dataset.label + " : " + context.parsed.y;
            },
            afterBody: function (tooltipItems) {
              if (!tooltipItems.length || !chartData?.tooltips) return "";

              const tooltipIndex = tooltipItems[0]?.dataIndex;
              const details = chartData?.tooltips[tooltipIndex];

              return details ? details : [];
            },
          },
        },
      },
      scales: {
        x: {
          reverse: true,
          title: { display: true, text: "Time Range" },
          ticks: { maxRotation: 90, minRotation: 90, autoSkip: false, stepSize: 1 },
        },
        y: {
          beginAtZero: true,
          min: 0,
          max: maxNumber,
          ticks: { stepSize: 10 },
          title: { display: true, text: "User Activity Count" },
        },
      },
    };
    setOption(theme === "Theme1" ? options1 : options2);
  }, [theme, maxNumber]);
  console.log("hioioioioioioioioio");
  return (
    <>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Load Post By Erp User</div>
        <div className="load-post-logo">
          <RefreshIcon handleRefetch={refetch} loading={loading} />
        </div>
      </div>
      <div>
      <div className="Page_Activity_Of_Accounts_Box">
        <LoadTable
          data={TableData}
          loading={loading}
          error={error}
          title={Key}
          settings={false}
          options={false}
          select={false}
        />
      </div>
    </div>
      {/* <div style={{ display: "flex" }}>
        <div style={{ marginLeft: "1%" }}>
          <input
            type="radio"
            name="themeOptionForUSerActivity"
            value="Theme1"
            checked={theme === "Theme1"}
            onChange={() => setThemeOption("Theme1")}
          />
          Theme1
          <input
            type="radio"
            name="themeOptionForUSerActivity"
            value="Theme2"
            checked={theme === "Theme2"}
            onChange={() => setThemeOption("Theme2")}
          />
          Theme2
        </div>
        <div style={{ marginLeft: "5%" }}></div>
      </div>
      <ChartAndTable
        chartData={chartData}
        options={options}
        data={TableData}
        error={error}
        tableKey={Key}
        isLoading={loading}
        colAddition={colAddition}
      /> */}
    </>
  );
};

export default UserActivity;
